module.exports = __webpack_public_path__ + "img/model_1000.6565bbb1.jpg";